import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Optional,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  faCompass,
  faQuestionCircle,
} from '@fortawesome/free-regular-svg-icons';
import {
  faChevronLeft,
  faChevronRight,
  faShieldHalved,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { IonRouterOutlet, ModalController } from '@ionic/angular';
import {
  Account,
  Post,
  createPostObject,
} from '@jaimo-solutions-gmbh/platform-services-module';
import { VerifiedTooltipComponent } from '@jaimo-solutions-gmbh/stage-components';
import { openConsent, openFullscreen, openShare } from '../../../helpers';
import { SwiperContainer } from 'swiper/element';
import { getSuggestedEntries } from '../../api/explore';
import { isBlacklisted } from 'src/app/utils/blacklist';

@Component({
  selector: 'app-initial-stream',
  templateUrl: './initial-stream.component.html',
  styleUrls: ['./initial-stream.component.scss'],
})
export class InitialStreamComponent implements OnInit {
  VerifiedComponent = VerifiedTooltipComponent;
  @ViewChild('swiper') swiper: ElementRef<SwiperContainer>;
  @Input() accounts: Account[];

  posts: Post[] = [];

  userIcon = faUser;
  privacyIcon = faShieldHalved;
  questionIcon = faQuestionCircle;
  exploreIcon = faCompass;

  slideNextIcon = faChevronRight;
  slidePrevIcon = faChevronLeft;

  isLoading: boolean = false;

  constructor(
    private router: Router,
    private modalCtrl: ModalController,
    @Optional() private routerOutlet: IonRouterOutlet
  ) {}

  ngOnInit() {
    this.getSuggestedPosts();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.swiper.nativeElement.swiper) return;

      this.swiper.nativeElement.swiper.params.breakpoints = {
        0: {
          slidesPerView: 1,
        },
        992: {
          slidesPerView: 2,
        },
      };
    }, 1);
  }

  getSuggestedPosts = async () => {
    this.isLoading = true;
    const result = await getSuggestedEntries();
    this.posts = result.map(createPostObject);
    this.isLoading = false;
    this.swiper.nativeElement.swiper.update();
  };

  explore = () => this.router.navigate(['explore']);

  openConsent = (url, source) =>
    openConsent(url, !isBlacklisted(url) ? undefined : source, this.modalCtrl);

  openFullscreen = ({ post, index }) =>
    openFullscreen(post, index, this.modalCtrl, this.routerOutlet.nativeEl);

  openShare = (post) => openShare(post, this.modalCtrl);

  goToStage = (account: Account) => {
    console.log(account);
    this.router.navigate([`/${account.handle}`]);
  };
}
